/*using-biome-with-turborepo*/
/*initialize-biome*/
/*create-a-root-task*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Biome",
  "description": "学习如何在 Turborepo 项目中使用 Biome。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Biome 是一个 JavaScript、TypeScript、JSX 和 JSON 的快速格式化程序，可节省持续集成 (CI) 和开发者的时间。"
  }, {
    "heading": "",
    "content": "¥Biome is a fast formatter for JavaScript, TypeScript, JSX, and JSON that saves CI and developer time."
  }, {
    "heading": "将-biome-与-turborepo-结合使用-using-biome-with-turborepo",
    "content": "¥Using Biome with Turborepo"
  }, {
    "heading": "将-biome-与-turborepo-结合使用-using-biome-with-turborepo",
    "content": "Biome 是 Turborepo 中使用的大多数工具中的一个罕见例外，因为它的速度非常快。因此，我们建议使用 根任务，而不是在每个包中创建单独的脚本。"
  }, {
    "heading": "将-biome-与-turborepo-结合使用-using-biome-with-turborepo",
    "content": "¥Biome is a rare exception to most tools that are used with Turborepo because it is so extraordinarily fast. For this reason, we recommend using a Root Task rather than creating separate scripts in each of your packages."
  }, {
    "heading": "将-biome-与-turborepo-结合使用-using-biome-with-turborepo",
    "content": "在项目根目录下使用 Biome 会导致升级 Biome 版本或更改配置时所有任务的缓存未命中。如果你在这些情况下更倾向于更高的缓存命中率而不是更少的配置，你仍然可以像我们指南中的其他建议一样，在单独的脚本中使用 Biome。"
  }, {
    "heading": "将-biome-与-turborepo-结合使用-using-biome-with-turborepo",
    "content": "¥Using Biome at the root of the project will result in cache misses for all\ntasks when you upgrade Biome versions or change configuration. If you prefer\nthe tradeoff of higher cache hit ratios in these situations over less\nconfiguration, you can still use Biome in separate scripts like the other\nrecommendations in our guides."
  }, {
    "heading": "初始化-biome-initialize-biome",
    "content": "¥Initialize Biome"
  }, {
    "heading": "初始化-biome-initialize-biome",
    "content": "首先，在你的仓库中添加 按照安装文档设置 Biome。然后，你将能够在存储库的根目录中创建一个使用 Biome 的脚本："
  }, {
    "heading": "初始化-biome-initialize-biome",
    "content": "¥First, follow the installation documentation to set up Biome in your repository. You'll then be able to create a script to use Biome in the root of your repository:"
  }, {
    "heading": "创建根任务-create-a-root-task",
    "content": "¥Create a root task"
  }, {
    "heading": "创建根任务-create-a-root-task",
    "content": "实际上，Biome 不太可能成为代码库迭代速度的瓶颈。因此，通过在 根任务 中使用 Biome，我们可以减少代码库中需要管理的配置。"
  }, {
    "heading": "创建根任务-create-a-root-task",
    "content": "¥In practice, Biome is unlikely to be a bottleneck in the iteration speed of your repository. For this reason, we can have less configuration to manage in our repository by using Biome in a Root Task."
  }, {
    "heading": "创建根任务-create-a-root-task",
    "content": "如果你认为将 Biome 拆分成多个任务放在包中运行速度会更快，你可以自由地这样做。我们鼓励你尝试最适合你用例的方案。"
  }, {
    "heading": "创建根任务-create-a-root-task",
    "content": "¥If you believe Biome may be faster in your repository split up into tasks in\npackages, you are free to do so. We encourage you to experiment with what's\nbest for your use case."
  }, {
    "heading": "创建根任务-create-a-root-task",
    "content": "要创建 根任务，请将脚本注册到 Turborepo："
  }, {
    "heading": "创建根任务-create-a-root-task",
    "content": "¥To create a Root Task, register the scripts to Turborepo:"
  }, {
    "heading": "创建根任务-create-a-root-task",
    "content": "现在你可以使用 turbo run format-and-lint 和 turbo run format-and-lint:fix 运行这些脚本。"
  }, {
    "heading": "创建根任务-create-a-root-task",
    "content": "¥You'll now be able to run these scripts using turbo run format-and-lint and turbo run format-and-lint:fix."
  }],
  "headings": [{
    "id": "将-biome-与-turborepo-结合使用-using-biome-with-turborepo",
    "content": "将 Biome 与 Turborepo 结合使用 /*using-biome-with-turborepo*/"
  }, {
    "id": "初始化-biome-initialize-biome",
    "content": "初始化 Biome /*initialize-biome*/"
  }, {
    "id": "创建根任务-create-a-root-task",
    "content": "创建根任务 /*create-a-root-task*/"
  }]
};
import {Callout} from '#components/callout';
import {CreateTurboCallout} from './create-turbo-callout.tsx';
export const toc = [{
  depth: 2,
  url: "#将-biome-与-turborepo-结合使用-using-biome-with-turborepo",
  title: _jsx(_Fragment, {
    children: "将 Biome 与 Turborepo 结合使用 "
  })
}, {
  depth: 3,
  url: "#初始化-biome-initialize-biome",
  title: _jsx(_Fragment, {
    children: "初始化 Biome "
  })
}, {
  depth: 3,
  url: "#创建根任务-create-a-root-task",
  title: _jsx(_Fragment, {
    children: "创建根任务 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://biome.nodejs.cn/",
        children: "Biome"
      }), " 是一个 JavaScript、TypeScript、JSX 和 JSON 的快速格式化程序，可节省持续集成 (CI) 和开发者的时间。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.a, {
        href: "https://biome.nodejs.cn/",
        children: "Biome"
      }), " is a fast formatter for JavaScript, TypeScript, JSX, and JSON that saves CI and developer time."]
    }), "\n", _jsx(CreateTurboCallout, {}), "\n", _jsx(_components.h2, {
      id: "将-biome-与-turborepo-结合使用-using-biome-with-turborepo",
      children: "将 Biome 与 Turborepo 结合使用 "
    }), "\n", _jsx(_components.p, {
      children: "¥Using Biome with Turborepo"
    }), "\n", _jsxs(_components.p, {
      children: ["Biome 是 Turborepo 中使用的大多数工具中的一个罕见例外，因为它的速度非常快。因此，我们建议使用 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#registering-root-tasks",
        children: "根任务"
      }), "，而不是在每个包中创建单独的脚本。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Biome is a rare exception to most tools that are used with Turborepo because it is ", _jsx(_components.strong, {
        children: "so extraordinarily fast"
      }), ". For this reason, we recommend using a ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#registering-root-tasks",
        children: "Root Task"
      }), " rather than creating separate scripts in each of your packages."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      title: "Caching behavior",
      children: [_jsx(_components.p, {
        children: "在项目根目录下使用 Biome 会导致升级 Biome 版本或更改配置时所有任务的缓存未命中。如果你在这些情况下更倾向于更高的缓存命中率而不是更少的配置，你仍然可以像我们指南中的其他建议一样，在单独的脚本中使用 Biome。"
      }), _jsx(_components.p, {
        children: "¥Using Biome at the root of the project will result in cache misses for all\ntasks when you upgrade Biome versions or change configuration. If you prefer\nthe tradeoff of higher cache hit ratios in these situations over less\nconfiguration, you can still use Biome in separate scripts like the other\nrecommendations in our guides."
      })]
    }), "\n", _jsx(_components.h3, {
      id: "初始化-biome-initialize-biome",
      children: "初始化 Biome "
    }), "\n", _jsx(_components.p, {
      children: "¥Initialize Biome"
    }), "\n", _jsxs(_components.p, {
      children: ["首先，在你的仓库中添加 ", _jsx(_components.a, {
        href: "https://biome.nodejs.cn/guides/getting-started/",
        children: "按照安装文档设置 Biome"
      }), "。然后，你将能够在存储库的根目录中创建一个使用 Biome 的脚本："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥First, ", _jsx(_components.a, {
        href: "https://biome.nodejs.cn/guides/getting-started/",
        children: "follow the installation documentation to set up Biome"
      }), " in your repository. You'll then be able to create a script to use Biome in the root of your repository:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"format-and-lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"biome check .\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"format-and-lint:fix\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"biome check . --write\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "创建根任务-create-a-root-task",
      children: "创建根任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Create a root task"
    }), "\n", _jsxs(_components.p, {
      children: ["实际上，Biome 不太可能成为代码库迭代速度的瓶颈。因此，通过在 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#registering-root-tasks",
        children: "根任务"
      }), " 中使用 Biome，我们可以减少代码库中需要管理的配置。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In practice, Biome is unlikely to be a bottleneck in the iteration speed of your repository. For this reason, we can have less configuration to manage in our repository by using Biome in a ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#registering-root-tasks",
        children: "Root Task"
      }), "."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsx(_components.p, {
        children: "如果你认为将 Biome 拆分成多个任务放在包中运行速度会更快，你可以自由地这样做。我们鼓励你尝试最适合你用例的方案。"
      }), _jsx(_components.p, {
        children: "¥If you believe Biome may be faster in your repository split up into tasks in\npackages, you are free to do so. We encourage you to experiment with what's\nbest for your use case."
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["要创建 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#registering-root-tasks",
        children: "根任务"
      }), "，请将脚本注册到 Turborepo："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To create a ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#registering-root-tasks",
        children: "Root Task"
      }), ", register the scripts to Turborepo:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"//#format-and-lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"//#format-and-lint:fix\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["现在你可以使用 ", _jsx(_components.code, {
        children: "turbo run format-and-lint"
      }), " 和 ", _jsx(_components.code, {
        children: "turbo run format-and-lint:fix"
      }), " 运行这些脚本。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You'll now be able to run these scripts using ", _jsx(_components.code, {
        children: "turbo run format-and-lint"
      }), " and ", _jsx(_components.code, {
        children: "turbo run format-and-lint:fix"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
